export type IconName =
  | "briefcase"
  | "chevrons"
  | "credit-card"
  | "dashboard"
  | "log-out"
  | "moon"
  | "panel"
  | "pen"
  | "scale"
  | "shield"
  | "sun"
  | "users";

const PATHS: Readonly<Record<IconName, readonly string[]>> = {
  briefcase: [
    "M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2",
    "M4 7h16a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2Z",
    "M2 12h20M10 12v2h4v-2",
  ],
  chevrons: ["m7 15 5 5 5-5", "m7 9 5-5 5 5"],
  "credit-card": [
    "M3 5h18a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Z",
    "M1 10h22",
  ],
  dashboard: [
    "M4 3h6v8H2V5a2 2 0 0 1 2-2ZM14 3h6a2 2 0 0 1 2 2v4h-8V3ZM2 15h8v6H4a2 2 0 0 1-2-2v-4ZM14 13h8v6a2 2 0 0 1-2 2h-6v-8Z",
  ],
  "log-out": ["M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4", "m16 17 5-5-5-5", "M21 12H9"],
  moon: ["M20.5 14.2A8.5 8.5 0 0 1 9.8 3.5 9 9 0 1 0 20.5 14.2Z"],
  panel: [
    "M4 3h16a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z",
    "M9 3v18",
  ],
  pen: ["M12 20h9", "M16.5 3.5a2.1 2.1 0 0 1 3 3L8 18l-4 1 1-4L16.5 3.5Z"],
  scale: ["M12 3v18M6 7h12M5 7l-3 6h6L5 7ZM19 7l-3 6h6l-3-6ZM8 21h8"],
  shield: ["M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z", "m9 12 2 2 4-5"],
  sun: [
    "M12 3V1M12 23v-2M4.2 4.2 2.8 2.8M21.2 21.2l-1.4-1.4M3 12H1M23 12h-2M4.2 19.8l-1.4 1.4M21.2 2.8l-1.4 1.4",
    "M17 12a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z",
  ],
  users: [
    "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
    "M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
    "M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75",
  ],
};

export const Icon = ({
  name,
  size = 18,
  className,
}: {
  readonly name: IconName;
  readonly size?: number;
  readonly className?: string;
}): React.JSX.Element => (
  <svg
    aria-hidden="true"
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {PATHS[name].map((path) => (
      <path d={path} key={path} />
    ))}
  </svg>
);
